import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function forgotPassword(data) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/user/sendresetpasswordmail',
        withCredentials: true,
        data
    }

    return axios(options)
}

export function resetPassword(data) {
    const options = {
        method: 'PUT',
        url: process.env.REACT_APP_URL + '/api/user/addnewpassword',
        withCredentials: true,
        data
    }

    return axios(options)
}



// WEBPACK FOOTER //
// ./src/utils/forgotPassword.js